import React from 'react';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import PanelContainer from '@/components/wrappers/PanelContainer';
import { fetchUser, updateUserPanels } from '../actions';
import { userPanels } from '../state/state';

const UserPanelContainer = ({
  canRead,
  children,
  exists,
  isDirty,
  name,
  onChange,
  readErrors,
  readStatus,
  url,
}) => (
  <PanelContainer
    canAccess={canRead}
    entity="user"
    exists={exists}
    isDirty={isDirty}
    name={name}
    onChange={onChange}
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={url}
  >
    {children}
  </PanelContainer>
);

const accessControl = (role, exists, isCurrentUser) => (
  {
    exists,
    canRead: exists ? isCurrentUser || role.permissions.users.read : isCurrentUser,
  }
);

const withoutItem = (role, isCurrentUser) => (
  {
    ...accessControl(role, false, isCurrentUser),
    ...readStates,
  }
);

const withItem = (item, role, isCurrentUser) => (
  {
    ...accessControl(role, true, isCurrentUser),
    user: item,
    readStatus: item.readStatus,
    readErrors: item.readErrors,
    name: item.name,
    panels: item.panels || userPanels().panels,
  }
);

export const mapStateToProps = ({
  auth: { role, users, currentUser },
}, { category, code }) => {
  const item = findResult(users, category, code);
  const isCurrentUser = code === currentUser.id;
  return item ? withItem(item, role, isCurrentUser) : withoutItem(role, isCurrentUser);
};

export const mapDispatchToProps = {
  fetchData: fetchUser,
  updatePanels: updateUserPanels,
};

export default UserPanelContainer;
